import React, { useContext, useEffect, useState } from "react";
import { TodosContext } from "../../../context/alert";
import { OrganisationService } from "../../organisation-management/service/organisationService";
import Container from "react-bootstrap/Container";
import { Col, Row } from "react-bootstrap";
import IconHome from "../../../styles/icons/IconHome";
import { withUserManagementControllerWrapper } from "../UserManagementControllerWrapper";
import { AddUserFormValidation } from "../../../utils/helpers/helperMethods/FormValidation";
import BreadCrumb from "../../../components/organisms/Breadcrumb/BreadCrumb";
import Headline from "../../../components/organisms/Headline/Headline";
import InputController from "../../../components/atoms/InputController/General/TextField-input/InputController";
import SelectController from "../../../components/atoms/InputController/General/TextField-input/SelectController";
import Loader from "../../../components/atoms/Loader/Loader";
import { useNavigate } from "react-router-dom";
import { handleMobileNumberChange } from "../../../utils/helpers/helperMethods/mobileNumberHandler";
import useUserRole from "../../../hooks/useUserRole";
import { USER_TYPE_IDS, UserRole } from "../../../utils";

const selectOptionsValue = [
  { value: USER_TYPE_IDS[UserRole.Administrator], label: "Admin" },
  { value: USER_TYPE_IDS[UserRole.Customer], label: "Customer" },
  { value: USER_TYPE_IDS[UserRole.Operator], label: "Operator" },
];
const globalAdminOption = {
  value: USER_TYPE_IDS[UserRole.GlobalAdmin],
  label: "Global Admin",
};
const AddUser = ({ ...hocProps }) => {
  const isGlobalAdmin = useUserRole() === UserRole.GlobalAdmin;
  const { addAlert } = useContext(TodosContext);
  const userTypeOptions = isGlobalAdmin
    ? [...selectOptionsValue, globalAdminOption]
    : selectOptionsValue;
  const defaultValue = selectOptionsValue[0];
  const [selectedFile, setSelectedFile] = React.useState<any>(true);
  const [isFilePicked, setIsFilePicked] = React.useState(false);
  const [selectedOption, setSelectedOption] = useState<any>(defaultValue);
  const [organisationOptions, setOrganisationOptions] = useState<
    { value: number; label: string }[]
  >([]);
  const [selectedOrganisation, setSelectedOrganisation] = useState<any>(null);
  const navigate = useNavigate();
  const [inputValue, setInputValue] = React.useState({
    email: "",
    firstName: "",
    lastName: "",
    jobTitle: "",
    companyName: "",
    mobileNumber: "",
    state: 1,
    type: defaultValue.value,
    profilePicture: "",
    note: "",
    requestStatus: 2,
    organizationId: null as number | null,
  });
  const [inputErrorValue, setInputErrorValue] = React.useState({
    email: { error: true, message: "Add Your Email Address" },
    firstName: { error: true, message: "Add Your First Name" },
    lastName: { error: true, message: "Add Your Last Name" },
    jobTitle: { error: true, message: "Add Your Job Title" },
    groupType: { error: true, message: "Add Your Group Type" },
    companyName: { error: true, message: "Add Your Company Name" },
    mobileNumber: { error: true, message: "Add Your Mobile Number" },
  });

  const {
    email,
    firstName,
    lastName,
    jobTitle,
    companyName,
    mobileNumber,
    note,
  } = inputValue;
  const [clickSubmit, setClickSubmit] = React.useState(false);

  useEffect(() => {
    AddUserFormValidation(inputValue, setInputErrorValue);
  }, [inputValue]);

  // Only global admins choose the organisation; other users are created in their own.
  useEffect(() => {
    if (!isGlobalAdmin) return;
    let isCancelled = false;
    OrganisationService.getOrganisationLookups()
      .then((organisations) => {
        if (isCancelled) return;
        setOrganisationOptions(
          organisations.map((o) => ({ value: o.id, label: o.name }))
        );
      })
      .catch(() => {
        if (!isCancelled) addAlert("Failed to load organisations", "error", true);
      });

    return () => {
      isCancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGlobalAdmin]);

  // Global Admin users are not tied to an organisation.
  const requiresOrganisation =
    isGlobalAdmin && inputValue.type !== USER_TYPE_IDS[UserRole.GlobalAdmin];

  const organisationError = {
    error: requiresOrganisation && !inputValue.organizationId,
    message: "Select an Organisation",
  };

  const handleChangeOrganisation = (selected: any) => {
    setSelectedOrganisation(selected);
    setInputValue((prev) => ({
      ...prev,
      organizationId: selected?.value ?? null,
    }));
  };
  const handleChange = (e: any) => {
    const { name, value } = e.target;

    if (name === "mobileNumber") {
      const formatted = handleMobileNumberChange(value);
      setInputValue((prev) => ({ ...prev, mobileNumber: formatted }));
      return;
    }

    setInputValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeOption = (selected: any) => {
    setSelectedOption(selected);
    const isGlobalAdminType =
      selected?.value === USER_TYPE_IDS[UserRole.GlobalAdmin];
    if (isGlobalAdminType) setSelectedOrganisation(null);
    setInputValue((prev: any) => ({
      ...prev,
      type: selected?.value,
      organizationId: isGlobalAdminType ? null : prev.organizationId,
    }));
  };
  const changeHandler = (event: any) => {
    var selectedFile = event.target.files[0];
    setProfileImage(selectedFile);
    setSelectedFile(selectedFile);
    setIsFilePicked(true);
  };
  const setProfileImage = (selectedFile: any) => {
    if (selectedFile) {
      var reader = new FileReader();
      reader.onload = (e: any) => {
        document
          .getElementById("imgshow")
          ?.setAttribute("src", e.target.result);
      };

      reader.readAsDataURL(selectedFile);
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    setClickSubmit(true);
    if (!isFilePicked) {
      setSelectedFile(null);
    }
    if (
      !(
        inputErrorValue.email.error ||
        inputErrorValue.firstName.error ||
        inputErrorValue.lastName.error ||
        inputErrorValue.jobTitle.error ||
        inputErrorValue.companyName.error ||
        inputErrorValue.mobileNumber.error ||
        organisationError.error
      )
    ) {
      if (isFilePicked) {
        hocProps.createUser(inputValue, selectedFile);
      } else {
        hocProps.createUser(inputValue, null);
      }
    }
  };

  const handleDisable = () => {
    // return inputErrorValue.email.error || inputErrorValue.firstName.error || inputErrorValue.lastName.error || inputErrorValue.designation.error || inputErrorValue.companyName.error || inputErrorValue.mobileNumber.error || inputErrorValue.mobileNumber.error || !isFilePicked;
    return false;
  };
  return (
    <Container fluid className="layout-bar">
      <BreadCrumb />
      <Headline name="Add User" />

      <form onSubmit={(e) => handleSubmit(e)}>
        <div className="box-container">
          <Row>
            <Col sm={8}>
              <div className="input-row">
                <InputController
                  value={email}
                  name="email"
                  placeholder="Email"
                  type={"email"}
                  onChange={(e) => handleChange(e)}
                  label="Email"
                  errors={inputErrorValue.email}
                  clickSubmit={clickSubmit}
                />
                <SelectController
                  value={selectedOption}
                  name={"User Type"}
                  placeholder={"User Type"}
                  type={"text"}
                  options={userTypeOptions}
                  onChange={handleChangeOption}
                  errors=""
                  clickSubmit={clickSubmit}
                />
              </div>
              <div className="input-row">
                <InputController
                  value={firstName}
                  name="firstName"
                  placeholder="First Name"
                  type={"text"}
                  onChange={(e) => handleChange(e)}
                  label="First Name"
                  errors={inputErrorValue.firstName}
                  clickSubmit={clickSubmit}
                />
                <InputController
                  value={lastName}
                  name="lastName"
                  placeholder="Last Name"
                  type={"text"}
                  onChange={(e) => handleChange(e)}
                  label="Last Name"
                  errors={inputErrorValue.lastName}
                  clickSubmit={clickSubmit}
                />
              </div>
              <div className="input-row">
                <InputController
                  value={jobTitle}
                  name="jobTitle"
                  placeholder="Job Title"
                  type={"text"}
                  onChange={(e) => handleChange(e)}
                  label="JobTitle"
                  errors={inputErrorValue.jobTitle}
                  clickSubmit={clickSubmit}
                />
                <InputController
                  value={companyName}
                  name="companyName"
                  placeholder="Company Name"
                  type={"text"}
                  onChange={(e) => handleChange(e)}
                  label="Company Name"
                  errors={inputErrorValue.companyName}
                  clickSubmit={clickSubmit}
                />
                {/*<SelectController name="groupType" placeholder="Group Type" type={"select"} options={options} value={groupType} onChange={e => handleChange(e)}  errors={inputErrorValue.groupType} clickSubmit={clickSubmit}/>*/}
              </div>
              <div className="input-row">
                <InputController
                  value={mobileNumber}
                  name="mobileNumber"
                  placeholder="+61 412 345 678"
                  type="text"
                  onChange={handleChange}
                  label="Mobile Number"
                  errors={inputErrorValue.mobileNumber}
                  clickSubmit={clickSubmit}
                />
                <InputController
                  value={note}
                  name="note"
                  placeholder="Note"
                  type={"text"}
                  onChange={(e) => handleChange(e)}
                  label="Note"
                  errors={null}
                  clickSubmit={clickSubmit}
                />
              </div>
              {requiresOrganisation && (
                <div className="input-row input-row--half">
                  <SelectController
                    value={selectedOrganisation}
                    name="organizationId"
                    placeholder="Select Organisation"
                    type={"text"}
                    options={organisationOptions}
                    onChange={handleChangeOrganisation}
                    errors={organisationError}
                    clickSubmit={clickSubmit}
                    menuFooter={{
                      label: "Add Organisation",
                      onClick: () => navigate("/organisations/add-organisation"),
                    }}
                  />
                </div>
              )}
            </Col>

            <Col sm={4}>
              {/*{*/}
              {/*    selectedFile ?  null : <span className="error-msg">{"Add Your Profile Picture"}</span>*/}
              {/*}*/}
              <div className={"profile-box"}>
                {/* <AddUserProfilePic/> */}
                <div className="camera-con">
                  <div className="image-upload">
                    <label htmlFor="file-input">
                      <IconHome breadcrumb={"camera"} activeColor={"#007BFF"} />
                    </label>
                    <img id="imgshow" />
                    <input
                      id="file-input"
                      type="file"
                      onChange={changeHandler}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div className="button-section box-container">
          <button
            className="btn btn-secondary me-3"
            type="button"
            onClick={() => navigate(-1)}
          >
            Back
          </button>

          <button
            className="btn btn-primary"
            type={"submit"}
            disabled={handleDisable()}
          >
            Submit
          </button>
        </div>
      </form>

      {hocProps.isLoading ? <Loader /> : null}
    </Container>
  );
};

export default withUserManagementControllerWrapper(AddUser);
